export const PLANDALF_GATES = {
  fallback: 'fallback',
  rollup: 'rollup',
  branding: 'branding',
} as const;

export type PlandalfGateName =
  (typeof PLANDALF_GATES)[keyof typeof PLANDALF_GATES];

export function currentFeatures() {
  return window.Bonjoro?.user?.features;
}

export function hasFallbackAccess(): boolean {
  return currentFeatures()?.canAccessFallbackVideos === true;
}

export function hasBrandingAccess(): boolean {
  return currentFeatures()?.shouldHideBonjoroBranding === true;
}

export function hasRollupAccess(quantity: number): boolean {
  const features = currentFeatures();
  if (!features?.canRollupGreets) return false;
  if (features.greetRollUpLimit == null) return true;
  return quantity <= features.greetRollUpLimit;
}

export function plandalfMode(): string {
  return window.Bonjoro?.plandalf_mode === 'live' ? 'live' : 'preview';
}
